<template>
    <div class="chat__header" :class="!chatData && 'chat_nav_close'">
        <vs-navbar class="px-2 lg:px-4 py-2 flex navbar-custom" color="white" type="flat">
            <div class="relative flex mr-1 lg:mr-4">
                <feather-icon
                    icon="MenuIcon"
                    @click="$store.commit('chat/SET_CHAT_SIDEBAR', true)"
                    class="mr-2 lg:mr-4 cursor-pointer"
                    v-if="isSidebarCollapsed" />
                <div v-if="chatData" @click="openChatInfo()" :class="publickChat && 'cursor-pointer'">
                    <vs-avatar v-if="chatInfo && chatInfo.avatar" class="m-0 border-2 border-solid border-white" size="40px" :src="chatInfo.avatar" />
                    <vs-avatar v-else class="m-0 border-2 border-solid border-white" :text="avatarText" size="40px" />
                </div>
            </div>
            <template v-if="chatData">
                <div @click="openChatInfo()" :class="publickChat && 'cursor-pointer'">
                    <h6>{{ chatInfo.full_name ? chatInfo.full_name : chatInfo.name }}</h6>
                    <div class="text-sm" v-if="chatInfo.is_public && chatData.is_active">{{chatMember}}</div>
                </div>
                <vs-chip v-if="chatInfo.is_public && chatData.is_active" class="ml-2 lg:ml-4 chat_chip" transparent color="primary">
                    {{$t('group_chat')}}
                </vs-chip>
                <vs-spacer></vs-spacer>
                <div v-if="publickChat && chatData.is_active">
                    <vs-dropdown class="cursor-pointer" vs-trigger-click>
                        <a class="flex items-center" href.prevent>
                            <feather-icon icon="MoreVerticalIcon" svgClasses="h-6 w-6" />
                        </a>
                        <vs-dropdown-menu>
                            <vs-dropdown-item
                                class="whitespace-nowrap"
                                @click="openChatInfo()">
                                    {{$t('chat_info')}}
                            </vs-dropdown-item>
                            <vs-dropdown-item
                                v-if="isAdmin || isModerator"
                                class="whitespace-nowrap"
                                @click="$store.commit('chat/SET_ADD_MEMBER_POPUP', true)">
                                    {{$t('add_participant')}}
                            </vs-dropdown-item>
                            <vs-dropdown-item
                                @click="$store.commit('chat/SET_DELETE_POPUP', true)"
                                v-if="isAdmin"
                                class="text-danger whitespace-nowrap">
                                    {{$t('remove')}}
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </template>
        </vs-navbar>
    </div>
</template>

<script>
import {declOfNum} from './utils'
import {mapState} from 'vuex'
export default {
    props: {
        chatData: {
            type: Object
        },
        isSidebarCollapsed: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        chatInfo() {
            if(this.chatData.is_public)
                return this.chatData
            else
                return this.chatData.recipient
        },
        isAdmin() {
            if(this.chatInfo.author.profileId === this.user.profileId)
                return true
        },
        isModerator() {
            if(this.chatInfo.is_moderator)
                return true
        },
        chatMember() {
            if(this.chatInfo.is_public)
                return this.chatInfo.member_count + ' ' + declOfNum(this.chatInfo.member_count, [this.$t('participant'), this.$t('participant2'), this.$t('participant3')])
        },
        publickChat() {
            if(this.chatInfo.is_public)
                return true
            else
                return false
        },
        avatarText() {
            let name
            if(this.chatInfo.is_public)
                name = this.chatInfo.name
            else
                name = this.chatInfo.full_name

            if(name) {
                // Возвращяем инициалы пользователя
                let title,
                    text = name
                const textAr = text.split(' ')
                if (textAr.length) {
                    const newTitle = []
                    textAr.forEach(item => {
                        newTitle.push(item.substr(0, 1).toUpperCase())
                    })
                    title = newTitle.join('')
                } else title = text.substr(0, 1)
                return title
            }
        }
    },
    methods: {
        openChatInfo() {
            if(this.publickChat && this.chatData.is_active)
                this.$store.commit('chat/CHANGE_INFO', true)
        }
    }
}
</script>

<style lang="scss">
.chat__navbar{
    .navbar-custom{
        min-height: 60px;
    }
}
.chat_nav_close{
    .vs-con-items{
        justify-content: flex-start;
    }
}
@media only screen and (max-width: 964px) {
    .chat_chip{
        display: none;
    }
}
</style>
